// src/locales.js

const locales = {
  en: {
    heroTitle1: "Transform Your Body,",
    heroTitle2: "Transform Your Life",
    heroSubtitle: "Experience personalized training with a certified coach who will guide you with programs made just for you.",
    heroPrimaryBtn: "Start Your Journey",
    heroSecondaryBtn: "Learn More",
    heroScrollPrompt: "SCROLL DOWN FOR MORE",
    aboutTitle1: "About",
    aboutTitle2: "me",
    aboutWho: "Who I am",
    aboutWhoText1: "My name is <b>Grigoris Stoupiadis</b> and I am a certified trainer from EHFA (European Health and Fitness Association), specialized in Olympic lifts from the General Secretariat of Sports.",
    aboutWhoText2: "I have completed certification in 'Nutrition and Exercise Science with Digital Applications' from the University of Athens.",
    aboutCerts: "Certifications & Specializations",
    aboutCertsList: ["TRX", "Functional Training", "Kettlebell", "Indoor Cycling", "Fitness Boxing"],
    aboutTeaching: "Education & Teaching",
    aboutTeachingText: "I love knowledge and share it daily as a practical course instructor at Grafts Hellas, one of the top fitness professional training schools in Greece.",
    aboutAthlete: "Athletic Background",
    aboutAthleteText: "I have been a member of the National Junior Weightlifting Team, an experience that taught me discipline, focus, and the value of hard work—values I apply in every training session.",
    aboutGoal: "My Goal",
    aboutGoalText1: "My goal is to offer you a personalized, safe, and effective exercise experience that fits your needs, time, and pace.",
    aboutGoalText2: "If you are ready to see results and feel better about your body, I am here to guide you step by step.",
    // Programs Section
    programsTitle1: "Personalized",
    programsTitle2: "Training Programs",
    programsList: [
      {
        heading: "Muscle Strengthening",
        details: "Training aimed at increasing strength and improving muscle performance.",
        button: "Start Now"
      },
      {
        heading: "Weight Loss",
        details: "Fat loss with targeted workouts & dietary guidance according to your goal.",
        button: "Learn More"
      },
      {
        heading: "Assessment & Safety",
        details: "Body measurements, fitness and strength assessment, and use of heart rate monitor for safe and targeted training.",
        button: "Discover"
      },
      {
        heading: "Rehabilitation & Reintegration",
        details: "Programs for people recovering from injuries or returning to exercise after a break.",
        button: "See Program"
      },
      {
        heading: "Cardiorespiratory Endurance",
        details: "Aerobic training to improve heart function and endurance.",
        button: "Try It"
      },
      {
        heading: "Nutritional Advice",
        details: "Personalized nutrition tips based on your needs.",
        button: "Nutrition Tips"
      },
      {
        heading: "Online Coaching",
        details: "Guidance and specialized programs remotely via the internet.",
        button: "Start Remotely"
      },
      {
        heading: "Mini Group / At Home",
        details: "Training for 2-3 people or at your place. Absolute flexibility and supervision.",
        button: "Book Session"
      }
    ],
    // Footer Section
    footerNavAbout: "Who I am",
    footerNavPrograms: "Programs",
    footerNavContact: "Contact",
    footerCopyright: "All rights reserved.",
    footerInstagram: "Instagram",
    footerFacebook: "Facebook",
    // Contact Section
    contactTitle1: "Book your",
    contactTitle2: "free",
    contactTitle3: "trial session",
    contactLocation: "Thessaloniki",
    contactName: "Name",
    contactEmail: "Email",
    contactMessage: "Message",
    contactSend: "Send Message",
    contactSuccess: "Your message was sent! I will contact you soon.",
    contactError: "Something went wrong. Please try again later.",
    contactNameError: "Name must be at least 6 characters.",
    contactEmailError: "Invalid email address.",
    contactMessageError: "Message must be at least 6 characters."
  },
  el: {
    heroTitle1: "Μεταμόρφωσε το Σώμα σου,",
    heroTitle2: "Μεταμόρφωσε τη Ζωή σου",
    heroSubtitle: "Ζήσε την εμπειρία εξατομικευμένης εκγύμνασης με πιστοποιημένο προπονητή, που θα σε καθοδηγήσει με προγράμματα φτιαγμένα μόνο για εσένα.",
    heroPrimaryBtn: "Ξεκινα το Ταξιδι",
    heroSecondaryBtn: "Περισσοτερα",
    heroScrollPrompt: "ΚΑΤΩ ΓΙΑ ΠΕΡΙΣΣΟΤΕΡΑ",
    aboutTitle1: "Σχετικά",
    aboutTitle2: "με εμένα",
    aboutWho: "Ποιος είμαι",
    aboutWhoText1: "Ονομάζομαι <b>Γρηγόρης Στουπιάδης</b> και είμαι πιστοποιημένος γυμναστής από την EHFA (European Health and Fitness Association), με εξειδίκευση στις Ολυμπιακές άρσεις από τη Γενική Γραμματεία Αθλητισμού.",
    aboutWhoText2: "Έχω ολοκληρώσει πιστοποίηση στην «Επιστήμη Διατροφής και Άσκησης με χρήση ψηφιακών εφαρμογών» από το Καποδιστριακό Πανεπιστήμιο.",
    aboutCerts: "Πιστοποιήσεις & Εξειδικεύσεις",
    aboutCertsList: ["TRX", "Functional Training", "Kettlebell", "Indoor Cycling", "Fitness Boxing"],
    aboutTeaching: "Εκπαίδευση & Διδασκαλία",
    aboutTeachingText: "Αγαπώ τη γνώση και τη μεταδίδω καθημερινά ως καθηγητής πρακτικών μαθημάτων στη Grafts Hellas, μια από τις κορυφαίες σχολές εκπαίδευσης επαγγελματιών fitness στην Ελλάδα.",
    aboutAthlete: "Αγωνιστικό Υπόβαθρο",
    aboutAthleteText: "Έχω υπάρξει μέλος της Εθνικής Ομάδας Εφήβων Άρσης Βαρών, μια εμπειρία που με δίδαξε πειθαρχία, στόχευση και την αξία της σκληρής δουλειάς — αξίες που εφαρμόζω και σήμερα σε κάθε προπόνηση.",
    aboutGoal: "Ο Στόχος μου",
    aboutGoalText1: "Ο στόχος μου είναι να σου προσφέρω μια προσωποποιημένη, ασφαλή και αποτελεσματική εμπειρία άσκησης που ταιριάζει στις ανάγκες, τον χρόνο και τον ρυθμό σου.",
    aboutGoalText2: "Αν είσαι έτοιμος/η να δεις αποτελέσματα και να νιώσεις καλύτερα με το σώμα σου, είμαι εδώ για να σε καθοδηγήσω βήμα-βήμα.",
    // Programs Section
    programsTitle1: "Εξατομικευμένα",
    programsTitle2: "Προγράμματα Προπόνησης",
    programsList: [
      {
        heading: "Μυϊκή Ενδυνάμωση",
        details: "Προπόνηση με στόχο την αύξηση της δύναμης και τη βελτίωση της μυϊκής απόδοσης.",
        button: "Ξεκίνα τώρα"
      },
      {
        heading: "Απώλεια Βάρους",
        details: "Λιποδιάλυση με στοχευμένα workouts & διατροφικές οδηγίες ανάλογα με τον στόχο.",
        button: "Μάθε περισσότερα"
      },
      {
        heading: "Αξιολόγηση & Ασφάλεια",
        details: "Σωματομετρικά τεστ, αξιολόγηση φυσικής κατάστασης και δύναμης, καθώς και χρήση καρδιοσυχνομέτρου για ασφαλή και στοχευμένη προπόνηση.",
        button: "Ανακάλυψέ το"
      },
      {
        heading: "Αποκατάσταση & Επανένταξη",
        details: "Προγράμματα για άτομα που αναρρώνουν από τραυματισμούς ή επανέρχονται στη γυμναστική μετά από διάστημα αποχής.",
        button: "Δες το πρόγραμμα"
      },
      {
        heading: "Καρδιοαναπνευστική Αντοχή",
        details: "Αερόβια προπόνηση για βελτίωση καρδιακής λειτουργίας και αντοχής.",
        button: "Δοκίμασέ το"
      },
      {
        heading: "Διατροφικές Συμβουλές",
        details: "Εξατομικευμένα tips διατροφής με βάση τις ανάγκες του ασκούμενου.",
        button: "Συμβουλές διατροφής"
      },
      {
        heading: "Online Coaching",
        details: "Καθοδήγηση και εξειδικευμένα προγράμματα από απόσταση μέσω internet.",
        button: "Ξεκίνα εξ αποστάσεως"
      },
      {
        heading: "Mini Group / Κατ’ Οίκον",
        details: "Προπόνηση 2-3 ατόμων ή στον χώρο σου. Απόλυτη ευελιξία και επίβλεψη.",
        button: "Κλείσε συνεδρία"
      }
    ],
    // Footer Section
    footerNavAbout: "Ποιος είμαι",
    footerNavPrograms: "Προγράμματα",
    footerNavContact: "Επικοινωνία",
    footerCopyright: "All rights reserved.",
    footerInstagram: "Instagram",
    footerFacebook: "Facebook",
    // Contact Section
    contactTitle1: "Κλείσε το",
    contactTitle2: "δωρεάν",
    contactTitle3: "δοκιμαστικό",
    contactLocation: "Θεσσαλονίκη",
    contactName: "Όνομα",
    contactEmail: "Email",
    contactMessage: "Μήνυμα",
    contactSend: "Αποστολή Μηνύματος",
    contactSuccess: "Το μήνυμά σου στάλθηκε! Θα επικοινωνήσω σύντομα μαζί σου.",
    contactError: "Κάτι πήγε στραβά. Προσπάθησε ξανά αργότερα.",
    contactNameError: "Το όνομα πρέπει να έχει τουλάχιστον 6 χαρακτήρες.",
    contactEmailError: "Μη έγκυρη διεύθυνση email.",
    contactMessageError: "Το μήνυμα πρέπει να έχει τουλάχιστον 6 χαρακτήρες."
  },
};

export default locales;
